module.exports = __webpack_public_path__ + "img/leftBar.1c9f523d.png";